module.exports = __webpack_public_path__ + "static/media/Yifu.facd2946.png";